import React from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const CompletionModal = ({ isOpen, onClose, chapterTitle, completionStats }) => {
  const navigate = useNavigate();

  if (!isOpen) return null;

  const handleTakeQuiz = () => {
    navigate('/quiz-assessment-interface');
  };

  const handleViewProgress = () => {
    navigate('/learning-progress-tracker');
  };

  return (
    <div className="fixed inset-0 bg-black/50 z-50 flex items-center justify-center p-4">
      <div className="bg-surface rounded-lg shadow-elevation-2 max-w-md w-full content-reveal">
        <div className="p-6">
          {/* Success Icon */}
          <div className="flex justify-center mb-4">
            <div className="w-16 h-16 bg-success/10 rounded-full flex items-center justify-center">
              <Icon name="CheckCircle2" size={32} className="text-success" />
            </div>
          </div>

          {/* Title */}
          <div className="text-center mb-6">
            <h2 className="text-xl font-heading font-bold text-text-primary mb-2">
              Presentation Complete!
            </h2>
            <p className="text-text-secondary">
              You've successfully completed "{chapterTitle}"
            </p>
          </div>

          {/* Stats */}
          <div className="bg-background rounded-lg p-4 mb-6">
            <div className="grid grid-cols-2 gap-4 text-center">
              <div>
                <div className="text-2xl font-bold text-primary">
                  {completionStats.slidesViewed}
                </div>
                <div className="text-xs text-text-secondary">Slides Viewed</div>
              </div>
              <div>
                <div className="text-2xl font-bold text-secondary">
                  {completionStats.timeSpent}
                </div>
                <div className="text-xs text-text-secondary">Time Spent</div>
              </div>
            </div>
          </div>

          {/* Achievement Badge */}
          <div className="flex items-center justify-center space-x-2 mb-6 p-3 bg-primary/5 border border-primary/20 rounded-lg">
            <Icon name="Award" size={20} className="text-primary" />
            <span className="text-sm font-medium text-primary">
              Chapter 3 Presentation Completed
            </span>
          </div>

          {/* Action Buttons */}
          <div className="space-y-3">
            <Button
              variant="primary"
              iconName="FileQuestion"
              iconPosition="left"
              onClick={handleTakeQuiz}
              fullWidth
              className="achievement-celebration"
            >
              Take Chapter Quiz
            </Button>
            
            <div className="grid grid-cols-2 gap-3">
              <Button
                variant="outline"
                iconName="TrendingUp"
                iconPosition="left"
                onClick={handleViewProgress}
                className="text-sm"
              >
                View Progress
              </Button>
              
              <Button
                variant="ghost"
                iconName="X"
                iconPosition="left"
                onClick={onClose}
                className="text-sm"
              >
                Close
              </Button>
            </div>
          </div>

          {/* Next Steps */}
          <div className="mt-6 pt-4 border-t border-border">
            <p className="text-xs text-text-secondary text-center">
              Ready to test your knowledge? Take the quiz to earn your completion badge!
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CompletionModal;